import { Link } from "react-router-dom";
import { TRANSLATIONS } from "@/i18n";

export const AppFooter = ({ lang }) => {
  const t = TRANSLATIONS[lang];
  return (
    <footer
      className="relative z-10 border-t-2 border-black bg-white mt-6"
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <div className="rule-editorial mb-6 opacity-40" />
        <div className="flex items-start justify-between flex-wrap gap-6">
          <div className="flex-1 min-w-[240px]">
            <p
              className="font-display font-semibold italic text-2xl sm:text-3xl leading-tight text-black max-w-md tracking-tight"
              data-testid="footer-tagline"
            >
              {t.footerTagline}
            </p>
            <p className="dossier-tag mt-3">Note de service · usage strictement professionnel</p>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-3 text-right">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[10px] uppercase tracking-[0.18em] font-bold text-[#4A4A4A]">
              <Link
                to="/how-it-works"
                className="hover:text-black hover:underline"
                data-testid="footer-howto"
              >
                Mode d&apos;emploi
              </Link>
              <span className="text-black/30">·</span>
              <Link
                to="/legal"
                className="hover:text-black hover:underline"
                data-testid="footer-legal"
              >
                Mentions légales
              </Link>
            </div>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] uppercase tracking-[0.18em] font-bold">
              <span className="text-[#4A4A4A]">cordialement.ai © 2026</span>
              <span className="text-black/30">·</span>
              <span className="text-[#4A4A4A]">
                by{" "}
                <a
                  href="https://leteletravailleur.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black border-b-2 border-black hover:bg-[#B5EAD7] transition-colors"
                  data-testid="by-letele-link"
                >
                  Le Télétravailleur
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
